import { notificationConstants } from "../_constants";

export function bulletin(state = {}, action) {
  switch (action.type) {
    case notificationConstants.GETBULLET_REQUEST:
      return {
        loading: true,
      };
    case notificationConstants.GETBULLET_SUCCESS:
      return {
        list: action.bulletin,
      };
    case notificationConstants.GETBULLET_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
